import styles from './WidgetStyles.module.css';

type UserMessageBubbleProps = {
    content: string;
};

export function UserMessageBubble({ content }: UserMessageBubbleProps) {
    return (
        <li className={`${styles.messageCard} ${styles.userMessageCard}`}>
            <span className={styles.userMessageBubble}>{content}</span>
        </li>
    );
}
